<template>


<div id="custom-side-menu" uk-offcanvas="flip: false; mode: push; overlay: true">
    <div v-show="isLoggedIn" class="uk-offcanvas-bar">
      <button class="uk-offcanvas-close uk-visible@m" type="button" uk-close></button>

        <div class = "menu-container">

          <!--the avatar and username-->
          <!--MOBILE ONLY -->
          <div class = "avatar menu-section uk-hidden@m">
            <!--//uk-hidden@m-->
              <Avatar size="50" :image="user.image || null"/>
              <div class = "name">{{user.name || 'Anonymous User' }}</div>
          </div>




          <div class = 'menu-section uk-hidden@m'>
            <menu-search></menu-search>
          </div>

          <div
              v-for="section in navigation"
              :key="section.section_title"
              :class="{'menu-section':true, 'uk-hidden@m':section.mobile_only}"
          >
            <div class="menu-section-title">{{section.section_title}}</div>
            <ul class="uk-iconnav uk-iconnav-vertical">
              <li
                      v-for="link in section.links"
                      v-if="link.condition"
                      :key="link.link"
              >
                <span :uk-icon="'icon:' + (link.icon || 'chevron-right') + ';ratio:1.2'"></span>
                <a
                        @click="() => link.action ? link.action() : $router.push(link.link)"
                >{{link.name}}</a>
              </li>
            </ul>
          </div>


          <!--for text info like data, status, whatever-->
          <!--ALL SCREEN SIZES-->
          <div class = "info">
            <div><strong>{{today}}</strong></div>
          </div>


        </div>

    </div>
</div>

</template>

<script>

  import Avatar from './Avatar.vue'
  import menuSearch from './search.vue'
  import UIkit from 'uikit'; // necessary for intro stuff
  import moment from 'moment'

	export default {
		name: "RightInfoPanel",
    props: ["data"],
    components: {
			Avatar,
      menuSearch,
    },
		data: function () {
			return {
              today: moment().format("MMMM-DD-YYYY"),
            }
		},
		methods: {
			logout: function () {
				this.$store.dispatch('logout')
						.then(() => this.$router.push('/login'));
			}

		},
		computed: {
			isLoggedIn: function () {
				return this.$store.state.user.logged_in;
			},
			user: function () {
				return {
					image_url: null,
					name: this.$store.state.user.data.first_name + " " + this.$store.state.user.data.last_name || null
				}
			},
      permissions: function() {
				 if(this.$store.state.user.data.permissions_list) {
				    return this.$store.state.user.data.permissions_list
                 } else {
				   return []
                 }
      },
			navigation: function () {
				let menu = [
					{
						section_title: "Navigation",
						mobile_only: true,
						links: [
							{
								icon: null, //default to chevron, doesn't need to be passed
								name: "Dashboard",
								link: "/dashboard/",
                condition: true,
							},
              {
								icon: null,
								name: "Arena",
								link: "/arena/",
                condition: this.permissions.includes('see-arena')
							},
							{
								icon: null,
								name: "Contact",
								link: "/help/",
                condition: true,
							},
						]
					},
					{
						section_title: "Account",
						mobile_only: true,
						links: [
                    {
                      icon: "sign-out", //default to chevron, doesn't need to be passed
                      name: "Log Out",
                      link: "#",
                      action: this.logout,
                      condition: true
                    },
                  ],
                }
              ]
              return menu

          }
        }
	}
</script>

<style lang="less" scoped>

  @import "../../assets/less/palette.less";
  @import "../../assets/less/theme.less";


  #custom-side-menu {
     height: 100vh;
      overflow: hidden;
  }

  .uk-iconnav-vertical {

    li {
      width: 100%;
      display: flex;
      font-size: 1.3em;

      a {
        margin-left: 1em;
        color: inherit;

        &:hover {
          text-decoration: none;
        }
      }

      &:hover {
        color: @secondary-4!important;
      }

    }

  }

  .menu-container {
     display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    height: 88vh;
    overflow-y: scroll;
    margin-top: 2em;


    .menu-section-title {
      font-size: 1.4em;
      margin-bottom: .8em;
      text-decoration: underline;
    }

    .menu-section {
       margin-bottom: 6vh;
    }

  }

  .info {
    color: @secondary-3;
  }

  .avatar {
     display: flex;
    width: 100%;
    align-items: center;
    font-size: 1.2em;

    .name {
      margin-left: 1em;
      max-width: 80%;
    }

  }


@media (max-width: @breakpoint-medium) {
  .menu-container {
    justify-content: flex-start;
  }
}


</style>
